// export const api_url = "http://127.0.0.1:8000";
export const api_url =
  process.env.NODE_ENV === "production"
    ? "http://57.128.61.101:90"
    : "http://127.0.0.1:8000";
